export default {
  remote: 'haproxy_front_door_mfe',
  name: 'haproxy-front-door',
  source: 'https://github.com/telus/haproxy-front-door-mfe',
  urlMapping: {
    localhost:
      'https://assets.wcpreview.telus.com/1287683008/haproxy-front-door-mfe/v1/mf2/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1287683008/haproxy-front-door-mfe/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1287683008/haproxy-front-door-mfe/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1287683008/haproxy-front-door-mfe/v1/mf2/mf-manifest.json',
  },
};
